<div class="time-picker-container">
  <!-- Label -->
  @if (label) {
    <label class="field-label" [class.required]="required">
      {{ label }}
    </label>
  }

  <!-- Input Field -->
  <div class="relative">
    <input
      type="text"
      [value]="displayValue()"
      (click)="toggleDropdown()"
      readonly
      [placeholder]="placeholder"
      [disabled]="disabled"
      class="time-input"
      [class.error]="hasError"
    />
    <button type="button" (click)="toggleDropdown()" [disabled]="disabled" class="time-icon">
      <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
        ></path>
      </svg>
    </button>
  </div>

  <!-- Error Message -->
  @if (errorMessage) {
    <div class="field-error">{{ errorMessage }}</div>
  }

  <!-- Time Dropdown -->
  @if (isDropdownOpen()) {
    <div class="time-dropdown" (click)="$event.stopPropagation()">
      <!-- Time Slots List -->
      <div class="time-slots-container">
        @for (timeSlot of timeSlots(); track timeSlot.value) {
          <button
            type="button"
            (click)="selectTime(timeSlot)"
            class="time-slot"
            [class.selected]="value() === timeSlot.value"
          >
            {{ timeSlot.label }}
          </button>
        }
      </div>
    </div>
  }
</div>

<!-- Click outside to close dropdown -->
@if (isDropdownOpen()) {
  <div class="fixed inset-0 z-40" (click)="closeDropdown()"></div>
}
